import React, {useEffect} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {fetchUserById, updateUser} from "../../store/user-slice"; // Adjust these imports according to your store
import {userSchema} from "../../schema/userSchema"; // Ensure you have a corresponding schema for users
import {getFormData} from "../../models/userModel"; // Adjust this import to match your model
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Form from "../../components/common/form/Form";
import {getValidatedLimit} from "../../components/Utility";

const UserEdit = () => {
    const params = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.user);
    const {limit, currentPage} = getValidatedLimit(pagination);

    const {
        items: users,
        updateStatus,
        fetchByIdStatus,
        error
    } = useSelector(state => state.user); // Adjust this selector to your user slice

    useEffect(() => {
        dispatch(fetchUserById(params.userId)); // Ensure you're using the correct ID parameter
    }, [dispatch, params.userId]);

    const user = users.find(user => user.id === params.userId); // Ensure correct ID matching

    useEffect(() => {
        if (updateStatus === "success") {
            navigate(`../../?page=${currentPage}&limit=${limit}`); // Adjust navigation as needed
        }
    }, [updateStatus, navigate, currentPage, limit]);

    const formSubmitHandler = (data) => {
        const updatedData = {...data, id: params.userId}
        delete updatedData.password; //password field not required in upadte user
        dispatch(updateUser(updatedData)); // Ensure this action is correctly defined
    };

    const formCancelHandler = () => {
        navigate(`../../?page=${currentPage}&limit=${limit}`); // Adjust navigation as needed
    };
    const schema = userSchema(); // Adjust the schema as necessary
    delete schema.password;
    const initialData = getFormData(user); // Make sure getFormData is correctly implemented for user data
    return (
        <>
            <SubHeader title="Update User">
                <Button to={`../../?page=${currentPage}&limit=${limit}`}
                        className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-8">
                        {fetchByIdStatus === "loading" && <p>Loading...</p>}
                        {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                        {fetchByIdStatus === "success" &&
                            <Form
                                onFormSubmit={formSubmitHandler}
                                onFormCancel={formCancelHandler}
                                schema={schema}
                                inline={false}
                                initialData={initialData}
                                status={updateStatus}
                                error={error}
                            />
                        }
                    </div>
                </div>
            </div>
        </>
    );
};

export default UserEdit;
